/* 年月選択のパーツ */
import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import { KeyValue } from '../types/KeyValue';
import Paragraph from '../molecules/Paragraph';

interface Props {
  year_id: string;
  month_id: string;
  label: string;
  need?: boolean;
  year_name: string;
  month_name: string;
  year_suffix: string;
  month_suffix: string;
  year: string;
  month: string;
  year_maxlength?: number;
  help_msg?: string;
  message?: string;
  handleChangeYear: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeMonth: (event: React.ChangeEvent<HTMLInputElement>) => void;
  year_placeholder: string;
  year_disabled: boolean;
  month_disabled: boolean;
  handleBlurYear?: VoidFunction;
  handleBlurMonth?: VoidFunction;
  sources: Array<KeyValue>;
  readonly?: boolean;
}

const InputYearMonth: React.FC<Props> = ({
  year_id,
  month_id,
  label,
  need,
  year_name,
  month_name,
  year_suffix,
  month_suffix,
  year,
  month,
  year_maxlength,
  help_msg,
  message,
  handleChangeYear,
  handleChangeMonth,
  year_placeholder,
  year_disabled,
  month_disabled,
  handleBlurYear,
  handleBlurMonth,
  sources,
  readonly,
}) => {
  const getLabel = () => {
    // monthがselect項目なので、選択中の文言を取得する
    const selected = sources.filter(src => {
      if (src.key === month) {
        return src.value;
      }
    });
    return selected.length === 1
      ? `${year}${year_suffix}${selected[0].value}${month_suffix}`
      : `${year}${year_suffix}${month_suffix}`;
  };
  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={year_disabled || month_disabled}
      content={
        year_disabled || month_disabled ? (
          <Paragraph label={getLabel()} />
        ) : (
          <>
            <Row>
              <Col xs={4} className="pr-2">
                <Form.Control
                  id={year_id}
                  type="text"
                  name={year_name}
                  onChange={handleChangeYear}
                  value={year}
                  placeholder={year_placeholder}
                  disabled={year_disabled || readonly}
                  onBlur={handleBlurYear}
                  maxLength={year_maxlength}
                />
              </Col>
              <Col xs={1} className="d-flex align-items-center justify-content-left px-0">
                {year_suffix}
              </Col>
              <Col xs={4} className="px-1">
                <Form.Control
                  id={month_id}
                  as="select"
                  custom
                  onChange={handleChangeMonth}
                  name={month_name}
                  disabled={month_disabled || readonly}
                  defaultValue={month}
                  onBlur={handleBlurMonth}
                >
                  {sources.map(src => {
                    return (
                      <option key={src.key} value={src.key}>
                        {src.value}
                      </option>
                    );
                  })}
                </Form.Control>
              </Col>
              <Col xs={3} className="d-flex align-items-center justify-content-left px-0">
                {month_suffix}
              </Col>
            </Row>
            <Messages help_msg={help_msg} valid_msg={message} />
          </>
        )
      }
    />
  );
};

export default InputYearMonth;
